import { render, staticRenderFns } from "./aShopDetailGroup.vue?vue&type=template&id=4be26148&scoped=true"
import script from "./aShopDetailGroup.vue?vue&type=script&lang=js"
export * from "./aShopDetailGroup.vue?vue&type=script&lang=js"
import style0 from "./aShopDetailGroup.vue?vue&type=style&index=0&id=4be26148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be26148",
  null
  
)

export default component.exports